import { createClient } from '@supabase/supabase-js';

const rawUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Końcowy slash w URL bywa przyczyną problemów z żądaniami REST / proxy
const supabaseUrl = rawUrl ? rawUrl.replace(/\/+$/, '') : '';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check .env.local file.');
}

/** Ujednolicony URL projektu (np. do health-checków i diagnostyki) */
export const SUPABASE_URL = supabaseUrl;
export const SUPABASE_ANON_KEY = supabaseAnonKey;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  global: {
    headers: {
      'Accept': 'application/json',
      // Nie ustawiamy Content-Type tutaj, aby Supabase mógł automatycznie
      // ustawić właściwy Content-Type dla różnych typów żądań (JSON dla API, multipart/form-data dla uploadów)
    },
  },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});
